import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography, Link } from '@mui/material';
import { usePractice } from './hooks/usePractice';
import { PracticeTable } from './PracticeTable';
import { CreatePracticeModal } from './CreatePracticeModal.tsx';
import { t } from 'i18next';
import { PracticeItem } from './components';
import { Dropdown, DropdownMenuItem } from '@components';
import { ImportPracticeModal } from '@views/pages/Admin/Practice/ImportPracticeModal.tsx';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import { theme } from '@store';
import { ArrowBack } from '@mui/icons-material';

export const Practice = () => {
  const {
    totalCount,
    entries = [],
    isLoading,
    selectedPracticeId,
    handleCloseDrawer,
    handleOpenPracticeDetails,
    isDrawerOpen,
    handleOpenCreatePracticeModal,
    handleCloseCreatePracticeModal,
    handleOpenImportPracticeModal,
    handleCloseImportPracticeModal,
    isCreatePracticeModalOpen,
    isImportPracticeModalOpen,
    isInitialFilters,
  } = usePractice();

  const dropdownMenu: DropdownMenuItem[] = [
    {
      iconName: 'medicalServices',
      label: t('adminPanel.practices.dropdown.addPractice'),
      onClick: handleOpenCreatePracticeModal,
    },
    {
      iconName: 'backup',
      label: t('adminPanel.practices.dropdown.importPractice'),
      onClick: handleOpenImportPracticeModal,
    },
  ];

  return (
    <>
      <Box
        sx={{
          cursor: 'pointer',
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
          width: 'fit-content',
        }}
      >
        <Link
          href={'/admin'}
          underline='always'
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <ArrowBackIcon sx={{ fontSize: '1.5rem' }} color='primary' />
          <Typography sx={{ color: 'primary' }}>
            {t('general.backToPrevious')}
          </Typography>
        </Link>
      </Box>
      <Box
        sx={{
          paddingTop: '1rem',
          gap: '1rem',
          display: 'flex',
          flexDirection: 'column',
          pb: '1rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box
              sx={{
                cursor: 'pointer',
                [theme.breakpoints.up('md')]: {
                  display: 'none',
                },
                width: 'fit-content',
              }}
            >
              <Link
                href={'/admin'}
                underline='always'
                sx={{
                  gap: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <ArrowBack
                  sx={{ fontSize: '2rem', color: 'rgba(0, 0, 0, 0.56)' }}
                  color='primary'
                />
              </Link>
            </Box>
            <Typography variant='h4'>
              {t('adminPanel.practices.title')}
            </Typography>
          </Box>
          <Dropdown menuList={dropdownMenu} />
        </Box>
      </Box>
      {entries.length === 0 && isInitialFilters && !isLoading ? (
        <Box
          sx={{
            height: 'calc(100vh - 310px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <MedicalServicesIcon
            sx={{ width: 56, height: 56, mb: 2 }}
            color='primary'
          />
          <Typography variant='h6'>
            {t('adminPanel.practices.noResults.title')}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.disabled' }}>
            {t('adminPanel.practices.noResults.subTitle')}
          </Typography>
        </Box>
      ) : (
        <PracticeTable
          rows={entries}
          totalCount={totalCount}
          onSelectPractice={handleOpenPracticeDetails}
          loading={isLoading}
          selectedRowId={selectedPracticeId}
        />
      )}
      {selectedPracticeId && (
        <PracticeItem
          open={isDrawerOpen}
          itemId={selectedPracticeId}
          handleClose={handleCloseDrawer}
        />
      )}
      <CreatePracticeModal
        isOpen={isCreatePracticeModalOpen}
        handleClose={handleCloseCreatePracticeModal}
        handleOpenPracticeDetails={handleOpenPracticeDetails}
      />
      <ImportPracticeModal
        isOpen={isImportPracticeModalOpen}
        handleClose={handleCloseImportPracticeModal}
      />
    </>
  );
};
